import axios from "axios";
import { useEffect, useState } from "react"

export const useInit = () => {

    const [state, setState] = useState({
        hayJornada: false,
        ultimoProceso: null,
        titulos: null,
        procesos: null
    });

    
    useEffect(() => {

        const ultimoProceso_req = axios.get(`${process.env.REACT_APP_PROD}/api/Procesos/max`);
        const titulos_req = axios.get(`${process.env.REACT_APP_PROD}/api/Titulos`);
        const procesos_req = axios.get(`${process.env.REACT_APP_PROD}/api/Procesos`);

        axios.all([ultimoProceso_req, titulos_req ,procesos_req])
             .then(axios.spread((...responses) => {
                 responses[0].data?
                 (
                    setState({
                        hayJornada: true,
                        ultimoProceso: responses[0].data,
                        titulos: responses[1].data,
                        procesos: responses[2].data
                    })
                 ) :
                 (
                    setState({
                        hayJornada: false,
                        ultimoProceso: null,
                        titulos: null,
                        procesos: null
                    })
                 )
             }))
        
    }, [])

    return state;

}
